import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type AssignPartsOrdersMutationVariables = Types.Exact<{
  orderIds: Array<Types.Scalars['bigint']['input']> | Types.Scalars['bigint']['input'];
  runId: Types.Scalars['bigint']['input'];
  stopId: Types.Scalars['bigint']['input'];
}>;


export type AssignPartsOrdersMutation = { __typename?: 'mutation_root', update_delivery_orders?: { __typename?: 'delivery_orders_mutation_response', affected_rows: number } | null };


export const AssignPartsOrdersDocument = gql`
    mutation assignPartsOrders($orderIds: [bigint!]!, $runId: bigint!, $stopId: bigint!) {
  update_delivery_orders(
    where: {id: {_in: $orderIds}}
    _set: {run_id: $runId, stop_id: $stopId, status: "assigned"}
  ) {
    affected_rows
  }
}
    `;
export type AssignPartsOrdersMutationFn = Apollo.MutationFunction<AssignPartsOrdersMutation, AssignPartsOrdersMutationVariables>;

/**
 * __useAssignPartsOrdersMutation__
 *
 * To run a mutation, you first call `useAssignPartsOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignPartsOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignPartsOrdersMutation, { data, loading, error }] = useAssignPartsOrdersMutation({
 *   variables: {
 *      orderIds: // value for 'orderIds'
 *      runId: // value for 'runId'
 *      stopId: // value for 'stopId'
 *   },
 * });
 */
export function useAssignPartsOrdersMutation(baseOptions?: Apollo.MutationHookOptions<AssignPartsOrdersMutation, AssignPartsOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignPartsOrdersMutation, AssignPartsOrdersMutationVariables>(AssignPartsOrdersDocument, options);
      }
export type AssignPartsOrdersMutationHookResult = ReturnType<typeof useAssignPartsOrdersMutation>;
export type AssignPartsOrdersMutationResult = Apollo.MutationResult<AssignPartsOrdersMutation>;
export type AssignPartsOrdersMutationOptions = Apollo.BaseMutationOptions<AssignPartsOrdersMutation, AssignPartsOrdersMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/partsDelivery/queries/assignPartsOrders.mutation.gql}
 */
export async function assignPartsOrders(
  variables: AssignPartsOrdersMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<AssignPartsOrdersMutation['update_delivery_orders']>
export async function assignPartsOrders(
  variables: AssignPartsOrdersMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<AssignPartsOrdersMutation>
export async function assignPartsOrders(
  variables: AssignPartsOrdersMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<AssignPartsOrdersMutation['update_delivery_orders'] | AssignPartsOrdersMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<AssignPartsOrdersMutation>(
    AssignPartsOrdersDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_delivery_orders
}